export default __webpack_public_path__ + "static/media/codeminati-screenshot.950f1247.png";